module.exports = __webpack_public_path__ + "img/signin.b4a4105e.png";